// eslint-disable-next-line import/prefer-default-export
export const MESSAGE_DATE_NAISSANCE_INVALIDE = "Le format de la date n'est pas correct.";
export const MESSAGE_DATE_INVALIDE = 'Le format de la date est invalide ( Exemple : 27/05/2001 )';
